<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  size?: string
  color?: string
  text?: string
}>()

const size = props.size ?? '22px'
const color = props.color ?? 'primary'
const text = props.text ?? ''

// Show avatar initials
const avatarText = computed(() =>
  text
    .split(' ')
    .map((name) => name.charAt(0).toUpperCase())
    .join('')
)
</script>

<template>
  <v-avatar :size="size" :color="color">
    <p class="avatar-initials text-white">
      {{ avatarText }}
    </p>
  </v-avatar>
</template>

<style scoped>
.avatar-initials {
  font-size: 11px;
}
</style>
